/**
 * Constants
 */

/**
 * The default API URL path
 */
export const DefaultApiPath = "/api";

/**
 * The API setting query parameter and local storage key
 */
export const ApiPathKey = "api";

/**
 * Query parameter name for region override
 */
export const RegionOverrideKey = "region";

/**
 * Query parameter names
 */
export const QueryParameterNames = {
    ApiPath: ApiPathKey,
    RegionOverride: RegionOverrideKey,
    ItemId: "itemId",
};
